import { render, staticRenderFns } from "./ExpandedBalanceReport.vue?vue&type=template&id=74f0cc1b&"
import script from "./ExpandedBalanceReport.vue?vue&type=script&lang=ts&"
export * from "./ExpandedBalanceReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports